import React from 'react';
import { ParallaxContext, useController } from 'react-scroll-parallax';
// styles
import 'src/scss/gameplan.scss';
// hooks
import gameplanMobileMedia from '../../hooks/gameplanMobileMedia';
import gameplanMedia from '../../hooks/gameplanMedia';
import useMediaQuery from 'src/hooks/useMediaQuery';
// lib
import handlePageTransition from 'src/lib/handle-page-transition';
// components
import SEO from 'src/components/SEO';
import GamePlanContent from '../../components/game-plan/GamePlanContent';
import GamePlanContentMobile from '../../components/game-plan/GamePlanContentMobile';


function GamePlanPage({ transitionStatus }) {
  let isDesktop = useMediaQuery('(min-width: 1024px)');
  const isServer = typeof window === 'undefined';
  const context = React.useContext(ParallaxContext)

  if (!isServer && context ) {
    const { parallaxController } = useController();
    handlePageTransition(parallaxController, transitionStatus);
  }

  const mobileImages = [];
  const images = [];
  const mobileMedia = gameplanMobileMedia();
  const media = gameplanMedia();

  mobileMedia.allCloudinaryMedia.edges.forEach(item => mobileImages.push(item.node.secure_url));
  media.allCloudinaryMedia.edges.forEach(item => images.push(item.node.secure_url));

  const vid01 =
  'https://player.vimeo.com/progressive_redirect/playback/736957265/rendition/1080p/file.mp4?loc=external&signature=ba28ed7ab7a2632f388b674cb35f29dd9fa94aa294e0e4732742a12efe92c568';

  return (
    <div>
      <SEO title="The Game Plan | Falkon Content" />
      <div className="gp">
        {isDesktop
          ? (<GamePlanContent images={images} videos={[vid01]} />)
          : (<GamePlanContentMobile images={mobileImages} videos={[vid01]} />)
        }
      </div>
    </div>
  );
}

export default React.memo(GamePlanPage);
